export default __webpack_public_path__ + "static/media/business-unit.7cc02b6b.svg";